import React from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Container,
} from "@mui/material";
import imageProfile from "../../images/img_ecom.png";

const Cornerstone = () => {
  return (
    <Box
      sx={{
        background: "linear-gradient(90deg, #1A237E, #7B1FA2)",
        padding: { xs: 2, sm: 4 }, // Padding for responsiveness
      }}
    >
      <Container>
        <Card
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "column", md: "row" },
            background: "transparent",
            boxShadow: "none",
            paddingLeft: { sm: "60px", xs: "16px" },
            paddingRight: { sm: "60px", xs: "16px" },
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CardMedia
            component="img"
            image={imageProfile}
            alt="CEO Image"
            sx={{
              width: { xs: "100%", sm: "100%", md: "550px" },
              height: "auto",
              borderRadius: "16px",
              objectFit: "cover",
              mb: { xs: 2, sm: 2, md: 0 },
            }}
          />
          <CardContent
            sx={{
              color: "white",
              padding: { xs: 2, sm: 3, md: 4 },
              textAlign: { xs: "center", sm: "center", md: "left" },
            }}
          >
            <Typography
              variant="h4"
              fontWeight={700}
              gutterBottom
              sx={{ color: "white", fontSize: { xs: "36px", sm: "36px" } }}
            >
              Our Cornerstone
            </Typography>
            <Typography
              variant="body1"
              paragraph
              sx={{ color: "white", fontSize: { xs: "16px", sm: "16px" } }}
            >
              As the CEO of a service-oriented company specializing in digital
              marketing and web development, I envision a future where our
              clients not only thrive but also redefine their industries. Our
              mission is to empower businesses with cutting-edge digital
              solutions that not only enhance their online presence but also
              foster meaningful connections with their audiences. We are
              committed to staying ahead of the curve, leveraging the latest
              technologies and trends to deliver innovative strategies that
              drive growth and engagement.
            </Typography>
            <Typography
              variant="body1"
              paragraph
              sx={{ color: "white", fontSize: { xs: "16px", sm: "16px" } }}
            >
              Together, we can transform challenges into opportunities, ensuring
              that our clients are not just participants in the digital
              landscape, but leaders who set the standard for excellence.
            </Typography>
            <Typography
              variant="h6"
              fontWeight={700}
              mt={2}
              sx={{ color: "white", fontSize: { xs: "16px", sm: "16px" } }}
            >
              Jay Arikatla
            </Typography>
            <Typography variant="body2" sx={{ color: "#fff" }}>
              Director
            </Typography>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};

export default Cornerstone;
